const Permissions = Object.freeze({
  Users: "users",
  Manufacturers: "manufacturers",
  Contacts: "contacts",
  Distributors: "distributors",
  ProductCategories: "product_categories",
  Products: "products",
  Clinics: "clinics",
  Orders: "orders",
} as const);

export type Permissions = (typeof Permissions)[keyof typeof Permissions];

export const PermissionLabels = Object.freeze({
  [Permissions.Users]: "Users",
  [Permissions.Manufacturers]: "Manufacturers",
  [Permissions.Contacts]: "Contacts",
  [Permissions.Distributors]: "Distributors",
  [Permissions.ProductCategories]: "Product Categories",
  [Permissions.Products]: "Products",
  [Permissions.Clinics]: "Clinics",
  [Permissions.Orders]: "Orders",
});

export default Permissions;
